export default __webpack_public_path__ + "static/media/watch_msg.60e881ab.png";